import { registerQuery, useQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getActivityHistoryByCrmCompanyIdRpc, getActivityHistoryByDealIdRpc } from '../../__generated__/chirp/com/hubspot/betcrmcustomersummary/rpc/ActivityHistoryRpc';
import { COMPANY } from 'customer-data-objects/constants/ObjectTypes';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
function getActivityHistory({
  objectId,
  objectType,
  limit,
  offset
}) {
  if (objectType === COMPANY) {
    return rpcClient.call(getActivityHistoryByCrmCompanyIdRpc, {
      request: {
        crmCompanyId: objectId,
        limit,
        offset
      }
    });
  } else {
    return rpcClient.call(getActivityHistoryByDealIdRpc, {
      request: {
        dealId: objectId,
        limit,
        offset
      }
    });
  }
}
const GetCustomerActivityHistoryFieldName = 'customerActivityHistory';
export const GET_CUSTOMER_ACTIVITY_HISTORY = registerQuery({
  args: ['objectType', 'objectId', 'limit', 'offset'],
  fetcher: getActivityHistory,
  fieldName: GetCustomerActivityHistoryFieldName
});
export function useActivityHistoryQuery(options) {
  return useQuery(GET_CUSTOMER_ACTIVITY_HISTORY, options);
}